import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { useSavingsStore } from '@/store/useSavingsStore'
import { useUserStore } from '@/store/useUserStore'

export const ResetFirstDepositOnRouteEntry: React.FC = () => {
  const location = useLocation()
  const setGoalTransferIn = useSavingsStore((state) => state.setGoalTransferIn)
  const user = useUserStore((s) => s.user)
  const displayCurrency = user?.display_currency || 'USD'

  useEffect(() => {
    // Сбрасываем суммы при входе на страницу first-deposit
    setGoalTransferIn({
      cryptoAmount: { amount: '0', code: 'USDT' },
      fiatAmount: { amount: '0', code: displayCurrency },
      triggerShake: false,
      isFiatMode: true, // Начинаем в фиат режиме
    })
  }, [location.pathname, setGoalTransferIn, displayCurrency])

  return null
}
